import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Center } from '@wegroup/design-system';

// Components
import RiskObjectIcon from '../../../../common/src/components/RiskObjectIcon';

interface Props {
  riskObjects: string[];
  supportedRiskObject: string[];
}

const SupportedRiskObjects: React.FC<React.PropsWithChildren<Props>> = ({
  riskObjects,
  supportedRiskObject,
}) => {
  const { t } = useTranslation();

  const theme = useContext(ThemeContext);

  const getRiskObjectColor = (riskObject: string) =>
    supportedRiskObject.includes(riskObject) ? theme.typo.title : '#e4e4e4';

  return (
    <Center flexDir="column" data-test-id="ProdFac_SupportedRiskobjects">
      <SubTitle>{t('Available insurances')}</SubTitle>
      <Icons>
        {riskObjects.map((riskObject) => (
          <RiskObjectIcon
            key={riskObject}
            isImmo={theme['isImmo']}
            riskObject={riskObject}
            color={getRiskObjectColor(riskObject)}
            size={25}
          />
        ))}
      </Icons>
    </Center>
  );
};

const Icons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;

  > svg {
    margin: 0 0.4rem;
    width: 25px;
    height: 25px;
  }

  @media screen and (max-width: 1704px) {
    justify-content: center;
  }
`;

const SubTitle = styled.p`
  text-align: left !important;
  color: ${({ theme }) => theme.labels.guaranteeText};
  font-size: 1.4rem;
  margin-bottom: 1rem;

  @media screen and (max-width: 1704px) {
    text-align: center !important;
  }
`;

export default SupportedRiskObjects;
